module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/053-ghana-b57d7fdc39b06ccd310fe3a3deab6d40.svg";